.compactContainer {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.toggleButton {
  padding: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.toggleButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.codeBlock {
  flex: 1;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 0.875rem;
  height: 31px;
  line-height: 1.25rem;
}

.validationText {
  padding-left: 32px;
  min-height: 1.25rem;
  height: 1.25rem;
  display: block;
  overflow: hidden;
}

.actionButtons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 32px;
}
